import axios from "axios";
import initializeAxios from "../util/Axios";

class SchoolService {
    constructor() {
        initializeAxios();
    }

    async getCurrentSchool() {
        const response = await axios.get("/api/school");
        return response.data;
    }
}

export default new SchoolService();
